import { z } from 'zod';

// zod は check / transform を宣言順に実行する。email() を先に置くと、前後に空白の付いた
// 貼り付け入力が trim される前に弾かれてしまうため、trim → lowercase → email の順で並べる。
export const emailChangeRequestSchema = z.object({
  newEmail: z.string().trim().toLowerCase().email('メールアドレスの形式が正しくありません'),
});
export type EmailChangeRequestInput = z.infer<typeof emailChangeRequestSchema>;

export const emailChangeOtpSchema = z.object({
  otp: z
    .string()
    .length(6, '6桁の確認コードを入力してください')
    .regex(/^\d{6}$/, '6桁の確認コードを入力してください'),
});
export type EmailChangeOtpInput = z.infer<typeof emailChangeOtpSchema>;
